export function deriveInitials(name: string | undefined | null): string {
  if (!name || !name.trim()) return 'GU';
  const words = name.trim().split(/\s+/);
  return words
    .slice(0, 2)
    .map(w => w[0].toUpperCase())
    .join('');
}
